import { GridColumnType } from "../../../data/gridColumnType";

export const CertificateIssuanceConfig = {
  columns: [
    {
      name: "Company Name",
      fieldName: "companyName",
      allowShort: false,
      colType: GridColumnType.Text,
    },
    {
      name: "Cert Number",
      fieldName: "c",
      colType: GridColumnType.Text,
    },

    {
      name: "MUA Status",
      fieldName: "muaStatus",
      colType: GridColumnType.Text,
    },

    {
      name: "Invoice Amount",
      fieldName: "totalAmount",
      colType: GridColumnType.Text,
    },
    {
      name: "Payment Status",
      fieldName: "paymentStatus",
      colType: GridColumnType.Text,
    },
    {
      name: "Status",
      fieldName: "status",
      colType: GridColumnType.Text,
    },
    {
      name: "Actions",
      colType: GridColumnType.ACTION,
      defaultAction: {
        allowEdit: false,
        allowDelete: false,
        otherAction: true,
      },
      colSetting: {
        btnText: "Issue",
        isDisable: "isDisable",
        btnClassName: "xero-sendbtn",
      },
    
    },
  ],
};
